import { unitList, delUnit } from './request';
import UnderwritingModel from './underwritingModel.vue';
export default {
  components: {
    UnderwritingModel
  },
  data() {
    return {
      underwritingShow: false,
      form: {
        name: '',
        abbreviation: ''
      },
      columns: [{
        slots: {
          title: 'id'
        },
        dataIndex: 'id',
        key: '1',
        align: 'center',
        width: 100
      }, {
        slots: {
          title: '承保单位'
        },
        dataIndex: 'name',
        key: '2',
        align: 'center'
      }, {
        slots: {
          title: '单位简称'
        },
        dataIndex: 'abbreviation',
        key: '3',
        align: 'center'
      }, {
        slots: {
          title: '更新时间'
        },
        dataIndex: 'updateAt',
        key: '4',
        align: 'center'
      }, {
        slots: {
          title: '操作'
        },
        width: 150,
        key: '5',
        align: 'center',
        scopedSlots: {
          customRender: 'action'
        }
      }],
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      data: []
    };
  },
  created() {
    this.getDataFun();
  },
  methods: {
    getDataFun() {
      let obj = this.form;
      obj.page = this.pagination.current;
      obj.pageSize = this.pagination.pageSize;
      unitList(obj).then(res => {
        console.log(res);
        this.data = res.items;
        this.pagination.total = res.totalNum;
      });
    },
    getUnitTable() {
      console.log(555);
      this.underwritingShow = false;
      this.pagination.current = 1;
      this.getDataFun();
    },
    handleAdd() {
      this.underwritingShow = true;
      this.$nextTick(() => {
        this.$refs.underwritingFrom.init({});
      });
    },
    handleStandardTableChange(val) {
      this.pagination = val;
      this.getDataFun();
    },
    handleDelete(val) {
      let _this = this;
      this.$alert(this.$t('是否确认删除该承保单位') + '？', {
        confirmButtonText: _this.$t('确定')
      }).then(() => {
        delUnit({
          unitId: val.unitId
        }).then(res => {
          _this.$message.success(_this.$t('删除成功') + '!');
          _this.getDataFun();
        });
      });
    },
    handleEdit(val) {
      this.underwritingShow = true;
      this.$nextTick(() => {
        this.$refs.underwritingFrom.init(val);
      });
    }
  }
};